// ======================================================================
// FILE: src/modules/wms/dashboard/components/DashboardKpiCard.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Reusable KPI Card
// ======================================================================

import React from "react";

export default function DashboardKpiCard({

  title,
  value,
  trend,
  trendType = "up",
  icon,
  borderColor = "#0d6efd",
  iconColor = "#0d6efd",
  onClick,

}) {

  return (

    <div
      className="card shadow-sm h-100"
      style={{
        borderTop: `4px solid ${borderColor}`,
        cursor: "pointer",
        transition: "0.2s",
      }}
      onClick={onClick}
    >

      <div className="card-body">

        <div className="d-flex justify-content-between">

          <div>

            <div
              className="text-muted"
              style={{
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              {title}
            </div>

            <h2
              className="fw-bold mb-2 mt-2"
            >
              {value}
            </h2>

            <small
              className={
                trendType === "up"
                  ? "text-success"
                  : "text-danger"
              }
            >
              {trend}
            </small>

          </div>

          <div>

            <i
              className={icon}
              style={{
                fontSize: 30,
                color: iconColor,
              }}
            />

          </div>

        </div>

      </div>

    </div>

  );

}